import SectionFindCinema from "@components/global/SectionFindCinema"
import HomeAbout from "@components/pages/home/home-about"
import HomeCareer from "@components/pages/home/home-career"
import HomeCover from "@components/pages/home/home-cover"
import HomeExperience from "@components/pages/home/home-experience"
import HomeInvestors from "@components/pages/home/home-investors"
import HomeJourney from "@components/pages/home/home-journey"
import HomeLocation from "@components/pages/home/home-location"
import HomeNews from "@components/pages/home/home-news"
import HomeOverview from "@components/pages/home/home-overview"
import HomeProduct from "@components/pages/home/home-product"
import { fetchAPI } from "lib/api"
import { Q_HOME_PAGE } from "lib/query"
import { metaDesc } from "src/helper/meta-desc"
import { convertHtmlToReact, extractMeta } from "src/mixins"

function HomePage({ data, locale }) {
  const pageData = data?.data?.meta
  const cover = extractMeta(pageData, "hero")
  const overview = extractMeta(pageData, "video")
  const about = extractMeta(pageData, "tentang_kami")
  const cinemaInNumbers = extractMeta(pageData, "cinema_dalam_angka")
  const location = extractMeta(pageData, "stats")
  const experience = extractMeta(pageData, "services")
  const news = {
    ...extractMeta(pageData, "news"),
    list: data?.news?.data,
  }
  const career = extractMeta(pageData, "karir")
  const product = { ...extractMeta(pageData, "cinema"), data: data?.product }
  const investor = extractMeta(pageData, "investors_area")
  return (
    <>
      <HomeCover data={cover} locale={locale} />
      <HomeOverview data={overview} locale={locale} />
      <HomeAbout data={{ ...about, cinemaInNumbers }} locale={locale} />
      <HomeLocation data={location} locale={locale} />
      <SectionFindCinema />
      <HomeProduct data={product} locale={locale} />
      <HomeExperience data={experience} locale={locale} />
      <HomeJourney
        data={
          experience &&
          convertHtmlToReact(experience[`hero_description_${locale}`])
        }
      />
      <HomeInvestors data={investor} stocks={data?.stocks} locale={locale} />
      <HomeNews data={news} locale={locale} />
      <HomeCareer data={career} locale={locale} />
    </>
  )
}
export default HomePage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await fetchAPI(Q_HOME_PAGE, {})
  return {
    props: {
      seo: {
        title: data?.data[`title_${locale}`] || "Home",
        description: metaDesc[`home_${locale}`],
      },
      page: "home",
      data,
      locale,
    },
    revalidate: 60,
  }
}
